'use client'

import type { NavGroup } from '@graftcode/design-system'
import { Icon, Tooltip } from '@graftcode/design-system'

import {
  ACADEMY_NAV_SECTIONS,
  IS_CODE_SANDBOX_ENABLED,
} from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-mobile-menu.const'

import { ACADEMY_ROUTES } from '@/shared/academy.const'
import { getAcademySidebarNavUrl, isAcademySidebarNavItemActive } from '@/shared/academy.utils'
import { ACADEMY_LAYOUT_TEST_IDS } from '@/shared/academy-test-ids.const'

import { getAcademyNavIcon } from './getAcademyNavIcon'

export function buildMenuItems(pathname: string): NavGroup[] {
  const path = pathname?.split('?')[0] || ''

  if (path.startsWith(ACADEMY_ROUTES.quickStart)) {
    return [
      {
        items: [
          {
            label: 'Back to Home',
            url: '/',
            icon: Icon.ArrowLeftRegular,
            active: false,
          },
        ],
      },
    ]
  }

  if (path.startsWith(ACADEMY_ROUTES.codeSandbox) && IS_CODE_SANDBOX_ENABLED) {
    return [
      {
        items: [
          {
            label: 'Back to Home',
            url: '/',
            icon: Icon.ArrowLeftRegular,
            active: false,
          },
        ],
      },
    ]
  }

  return ACADEMY_NAV_SECTIONS.map((section) => ({
    label: section.label,
    items: section.items.map((item) => {
      const isCodeSandboxItem = item.id === 'codeSandbox'
      const disabled = isCodeSandboxItem ? !IS_CODE_SANDBOX_ENABLED : false

      const active =
        item.id === 'home'
          ? path === '' || path === '/'
          : disabled
            ? false
            : isAcademySidebarNavItemActive(item.id, path)

      return {
        id: item.id,
        label: item.label,
        url: getAcademySidebarNavUrl(item),
        icon: getAcademyNavIcon(item.icon, active),
        active,
        disabled,
        slotRight:
          isCodeSandboxItem && !IS_CODE_SANDBOX_ENABLED ? (
            <Tooltip content="Coming soon" placement="bottom" showArrow>
              <span
                data-testid={ACADEMY_LAYOUT_TEST_IDS.codeSandboxTooltip}
                aria-hidden
                style={{
                  position: 'absolute',
                  inset: 0,
                  pointerEvents: 'auto',
                  cursor: 'help',
                }}
              />
            </Tooltip>
          ) : undefined,
      }
    }),
  }))
}
